import {DatabaseCode, toDatabaseCode} from "./database-code";

export interface Language extends DatabaseCode {
  bcp47Code?: string
}

const enUS: Language = {
  code: 'en_us',
  displayValue: {
    id: 'common.languages.en.us',
    defaultMessage: 'English (United States)',
  },
  bcp47Code: "en-US",
};

const enCA: Language = {
  code: 'en_ca',
  displayValue: {
    id: 'common.languages.en.ca',
    defaultMessage: 'English (Canada)',
  },
  bcp47Code: "en-CA",
};

const esMX: Language = {
  code: 'es_mx',
  displayValue: {
    id: 'common.languages.es.mx',
    defaultMessage: 'Spanish (Mexico)',
  },
  bcp47Code: "es-MX",
};

const esUS: Language = {
  code: 'es_us',
  displayValue: {
    id: 'common.languages.es.us',
    defaultMessage: 'Spanish (United States)',
  },
  bcp47Code: "es-US",
};

export const language = {
  enUS,
  enCA,
  esMX,
  esUS,
};

export const languages = Object.values(language);

export const toLanguage = (code: string): Language => toDatabaseCode(code, languages);
export const toLanguageSafely = (code: string | undefined): Language | undefined => code ? toDatabaseCode(code, languages) : undefined;
